/**
 * The one question about SQL instances, asked for every product, level and DB server choice, and its limits. The one place to change
 * them; the backend mirrors them in apps/infrastructure/config/storage.py.
 */
export const SQL_INSTANCE_QUESTION = 'Do you need an ODBC connection / new SQL instance?'
/** A named SQL instance is at most this long. */
export const SQL_INSTANCE_NAME_MAX = 15
export const SQL_INSTANCE_NAME_HINT = `Up to ${SQL_INSTANCE_NAME_MAX} characters; start with a letter or underscore, then letters, digits, _, $ or #.`
/** Instance names SQL Server keeps for itself. */
export const RESERVED_SQL_INSTANCE_NAMES: readonly string[] = ['default', 'mssqlserver']

/** What No means: the server's main (default) instance is used. */
export const mainInstanceNote = (serverName: string): string => `The main SQL Server instance on ${serverName} will be used.`
